<template>
  <div class="searchResults" v-if="getShowResultBox">
    <SettingsWrapper v-if="settings.active" :dialogId="settings.dialogId" @close="onSettingsClose"/>
    <div class="label" v-if="getResult.length > 0">Search Results: {{ getResult.length }}</div>
    <div class="result-box" v-if="getResult.length > 0 && !getSearching">

      <div class="dialog-wrapper" v-for="dialog in getResult" :key="dialog._id">
        <DialogCard :search="true" :shortId="dialog.shortId" :id="dialog._id" v-if="dialog.owner == getUserId" @remove="onDelete" @share="onShareOpen" @reload="onReload" @openSettings="onSettingsOpen"/>
        <OthersCard :id="dialog._id" :pinned="dialog.pinned" @share="onShareOpen" @reload="onReload" v-else/>
      </div>

    </div>
    <div class="no-results" v-if="getResult.length == 0 && !getSearching">No results</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OthersCard from './OthersCard'
import DialogCard from './DialogCard'
import SettingsWrapper from '@/components/Main/SettingsWrapper'

export default {
  name: 'SearchResults',
  components: {
    OthersCard,
    DialogCard,
    SettingsWrapper,
  },
  data() {
    return {
      settings: {
        active: false,
      },
    }
  },
  methods: {
    ...mapActions('main', ['deleteFromResults']),
    onDelete(shortId) {
      this.deleteFromResults(shortId);
      this.$emit('remove', shortId);
    },
    onShareOpen(payload) {
      this.$emit('share', payload);
    },
    onReload() {
      this.$emit('reload');
    },
    onSettingsOpen(dialogId) {
      this.settings.active = true;
      this.settings.dialogId = dialogId;
    },
    onSettingsClose() {
      this.settings.active = false;
    },
  },
  computed: {
    ...mapGetters('main', ['getResult', 'getSearching', 'getShowResultBox', 'getUserId']),
  }
}
</script>

<style lang="scss" scoped>
.searchResults {
  width: 55rem;
  height: auto;
  margin-bottom: 2rem;
  @media (max-width: 900px) {
    width: 90vw;
  }

  .label {
    width: 100%;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.212);
  }

  .loading-box {
    width: 100%;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .result-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2rem;

    .dialog-wrapper {
      width: 55rem;
      height: auto;
      @media (max-width: 900px) {
        width: 90vw;
      }
    }
  }

  .no-results {
    width: 100%;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(0, 0, 0, 0.24);
    font-size: 1.3rem;
  }
}
</style>